<template>
  <div class="" style="position:fixed">
      <b-container fluid style="padding-top: 100px; ">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>


        <b-row>
          <b-col cols="12" style="height:75vh; overflow-y:scroll;width:99vw">
            <div class="cntnt">
<br>
          <div id="Fin1">
            <b-row>
              <b-col cols="12" style="text-align:center!important">
                  <h3 style="font-weight:600"> APDCL PAN : AABCL1354J </h3>
              </b-col>

           </b-row>
           <p class="content">
              <b-table bordered :items="PanDetails" :fields="Panfields">
                <template v-slot:cell(name)="data">
                 <span   v-html="data.value"></span>
                </template>
                <template v-slot:cell(date)="data">
                  <span   v-html="data.value"></span>
                </template>
              </b-table>
            </p>
            <b-row>
              <b-col col cols="12" sm="3" md="3" lg="3" offset-md="4" offset-lg="4">
                  <b-button block squared variant="primary"  id="button"  @click="generate('APDCL_ITR_Details')">
                    Print
                  </b-button>
                   <br>
              </b-col>
            </b-row>
          </div>

          </div>
          </b-col>
        </b-row>
      </b-container>
      <br><br>
  </div>
</template>



<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import { mapGetters, mapActions } from 'vuex'
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
export default {

  components: {
      'HeaderFixed' : HeaderFixed,
      'HeaderMobile' : HeaderMobile
    },
  data() {
      return {
        Panfields: [
          { key: 'finYear', label: 'Financial Year',thStyle: {width: '30vw'} },
          { key: 'ackNo', label: 'ITR Acknowledge No.',thStyle: {width: '30vw'} },
          { key: 'DoF', label: 'Date of Filing',thStyle: {width: '30vw'} }
        ],
        PanDetails:[
          {"finYear":"2018-19","ackNo":"243963561311019","DoF":"31/10/2019"},
          {"finYear":"2019-20","ackNo":"251255291110221","DoF":"11/02/2021"},
        ]

      }

  },
  methods:
  {
    generate(filename) {
      var header = ['Financial Year','Income Tax Return Acknowledgement No.','Date of Filing']
      var temp = []
//      temp.push(this.KeOfficialfields)
      temp.push(header)

      this.PanDetails.forEach(element => {
        var temp1 = [ element.finYear, element.ackNo, element.DoF]
        temp.push(temp1)
      })

console.log(temp)
var currentDate = new Date()

var dd = currentDate.getDate();
    var mm = currentDate.getMonth() + 1;

    var yyyy = currentDate.getFullYear();
    if (dd < 10) {
        dd = '0' + dd;
    }
    if (mm < 10) {
        mm = '0' + mm;
    }
    var today = dd + '/' + mm + '/' + yyyy;

      var docDefinition = {
        pageSize: 'A4',
        pageOrientation: 'portrait',
        content: [
          // { text: 'Assam Power Distribution Company Limited', style: 'header' },
          { text: ' APDCL PAN : AABCL1354J', style: 'subheader' },

          {
              style: 'tableExample',
            layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#80deea ' : null;
                    },

                },

  				   table: {
               headerRows: 1,
  				        body: temp
                     }
          },
          { text: 'Generated Date: ' + today  + ' ' + currentDate.toLocaleTimeString() , style: 'normalText'},
             ],
             styles: {
                  header: {
                  fontSize: 20,
                  bold: true,
                  alignment: 'left',
                  margin: [0, 0, 0, 5]
              },
            subheader: {
                fontSize: 20,
                alignment: 'left',
                bold: true,
                margin: [0, 10, 0, 5]
            },
            normalText: {
                fontSize: 8,
                alignment: 'left',
                margin: [0, 10, 0, 5]
            },
            tableExample: {
                margin: [0, 5, 5, 0],
                alignment: 'left',
                fontSize: 15,
            }
        },

      };

      pdfMake.createPdf(docDefinition).download(filename + ".pdf");
    }
  }

}
</script>

<style scoped="true">
li{
  padding:0;
}

    body{
      overflow-y:hidden;
    }
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;

}
.content{
    text-align: justify;
line-height: 1.5rem;
font-size:0.9rem;
}
.cntnt{
box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
padding:10px 30px 10px 30px;


}

table{
  text-align: center !important;
}
.headerF{
  display: block;
}
.headerM{
  display: none;
}

@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
  }

</style>
